import { useProjects } from '../lib/projects';
import { useSections } from '../lib/sections';

interface TodoMoveFieldsProps {
  projectId: number;
  sectionId: number | null;
  onChange: (next: { projectId: number; sectionId: number | null }) => void;
}

/**
 * Projekt- und Sektions-Auswahl im Bearbeiten-Modus eines Todos — damit
 * lässt sich ein Todo einer anderen Sektion zuweisen oder in ein anderes
 * Projekt verschieben. Beim Projektwechsel springt die Sektion auf
 * "Allgemein", weil die alte Sektion zum alten Projekt gehört.
 */
export function TodoMoveFields({ projectId, sectionId, onChange }: TodoMoveFieldsProps) {
  const projectsQ = useProjects({ is_archived: false });
  const sectionsQ = useSections(projectId);
  const projects = projectsQ.data ?? [];
  // Archiviertes Projekt taucht in der Liste nicht auf — trotzdem als
  // Option führen, sonst würde der Select still das erste Projekt zeigen.
  const currentMissing = !projectsQ.isLoading && !projects.some((p) => p.id === projectId);

  return (
    <div className="todo-move-fields">
      <label className="todo-move-fields__field">
        <span className="form-label">Projekt</span>
        <select
          value={projectId}
          onChange={(e) => onChange({ projectId: Number(e.target.value), sectionId: null })}
          disabled={projectsQ.isLoading}
        >
          {currentMissing && <option value={projectId}>(aktuelles Projekt)</option>}
          {projects.map((p) => (
            <option key={p.id} value={p.id}>
              {p.order_number} {p.title}
            </option>
          ))}
        </select>
      </label>
      <label className="todo-move-fields__field">
        <span className="form-label">Sektion</span>
        <select
          value={sectionId ?? ''}
          onChange={(e) =>
            onChange({ projectId, sectionId: e.target.value ? Number(e.target.value) : null })
          }
          disabled={sectionsQ.isLoading}
        >
          <option value="">Allgemein</option>
          {(sectionsQ.data ?? []).map((s) => (
            <option key={s.id} value={s.id}>
              {s.name}
            </option>
          ))}
        </select>
      </label>
    </div>
  );
}
